// FAZ-53 — Başvuru kanalı ikon sözlüğü.
//
// TEK KAYNAK: yeni bir kanal (WhatsApp vb.) eklendiğinde buraya bir satır
// yeter — liste, detay ve bilgi paneli aynı sözlükten beslenir.
//
// Sunucu ileride bu arayüzün tanımadığı bir kanal kodu göndermeye başlarsa
// getChannelMeta 'bireysel'e düşer: eski derleme KIRILMAZ, nötr ikon gösterir.

import { UserIcon } from "@heroicons/react/24/outline";

import HeadsetIcon from "./HeadsetIcon";

export const CHANNEL_BIREYSEL = "bireysel";
export const CHANNEL_HALK_MASASI = "halk_masasi";

export const CHANNEL_META = {
  [CHANNEL_BIREYSEL]: {
    label: "Bireysel başvuru",
    Icon: UserIcon,
    className: "channel-icon channel-icon--neutral",
  },
  [CHANNEL_HALK_MASASI]: {
    label: "Halk Masası",
    Icon: HeadsetIcon, // çağrı merkezi kulaklığı — telefon DEĞİL
    className: "channel-icon channel-icon--blue",
  },
  // İleride:
  // whatsapp: { label: "WhatsApp", Icon: WhatsAppIcon, className: "channel-icon channel-icon--green" },
};

export const getChannelMeta = (code) =>
  CHANNEL_META[code] || CHANNEL_META[CHANNEL_BIREYSEL];

export default CHANNEL_META;
